module.exports = __webpack_public_path__ + "img/BFFO.b7bb92bb.png";